var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "titlebar",
      style: {
        color: _vm.title_data && _vm.title_data.color,
        backgroundColor: _vm.title_data && _vm.title_data.backgroundColor,
      },
      attrs: { id: "titlebar", title: _vm.title_data && _vm.title_data.title },
    },
    [
      _c("span", {
        staticClass: "back btn",
        style: { background: _vm.title_data && _vm.title_data.maskColor },
        on: { click: _vm.go_back },
      }),
      _vm._v(" "),
      _vm.$slots["title-bar-right-part"]
        ? _c(
            "div",
            { staticClass: "right-part", style: _vm.title_data.right },
            [_vm._t("title-bar-right-part")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }